export enum Role {
  rolePublic = 'ROLE-PUBLIC',
  roleCCJAdmin = 'ROLE-CCJ-ADMIN',
}
